<div class="user-chip-container">
  <div class="user-avatar">
    <img 
      [src]="getUserAvatarUrl()" 
      [alt]="user.name + ' avatar'"
      class="avatar-img"
    />
  </div>
  
  <div class="user-info">
    <div title="{{ user.name }}" class="user-name">{{ user.name }}</div>
    <div title="{{ user.email }}" class="user-email">{{ user.email }}</div>
  </div>
  
  <button 
    *ngIf="showRemove"
    class="remove-button"
    (click)="onRemoveClick()"
    [attr.aria-label]="'Remove ' + user.name"
    type="button"
  >
    <span class="icon-close"></span>
  </button>
</div>